<template>
  <div id="app">
    <router-view />
    <template v-if="readyMode == 'mobile'">
      <!-- 拖拽 -->
      <Box :showRedDot="showRedDot"/>
    </template>
  </div>
</template>

<script>
import api from "./api";
import Vue from "vue";
import $ from "jquery";
import store from "./api/store";
import Box from "@/components/common/Box";

export default {
  name: "App",
  components: {
    Box,
  },
  data() {
    return {
      readyMode: "mobile",
      showRedDot: false,
    };
  },
  methods: {
    getRedDot() {
    //  积分转盘的红点
      api.homepage.getShowRedDot(res => {
        this.showRedDot = res.show;
      });
    }
  },
  created() {
    api.pagestate.start(this);
  },
  mounted() {
    //根据窗口大小来适配页面，主要为八达场地机器适配，分辨率 1080 x 1220
    var winWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    var winHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
    console.log(`屏幕分辨率:${winWidth}x${winHeight}`);
    var winScale = winHeight / winWidth;
    var minLandscapeScale = 1100 / 1080;
    var maxLandscapeScale = 1300 / 1080;

    if (winScale > minLandscapeScale && winScale < maxLandscapeScale) {
      //如果分辨率在范围内，则设置为landscape
      this.readyMode = "landscape";
    };

    this.getRedDot()
  }
};

</script>

<style lang="less">
html,
body {
  font-family: "PingFang SC", miui, system-ui, -apple-system, BlinkMacSystemFont,
    "Helvetica Neue", Helvetica, sans-serif;
  height: 100%;
  margin: 0px;
  padding: 0px;
  //background: #f5f5f5;
  background: #fff;
  color: @textColor;
  //用于解决iOS浏览器滚动卡滞的问题
  // -webkit-overflow-scrolling: touch; //可选值： touch: 当手指从触摸屏上移开，会保持一段时间的滚动; auto: 当手指从触摸屏上移开，滚动会立即停止
  -webkit-font-smoothing: antialiased;
}
#app{
  height: 100%;
}

a {
  text-decoration: none;
  color: inherit;
}

input,
textarea {
  border: 0; /* 方法1 */
  -webkit-appearance: none; /* 方法2 */

  &:focus {
    outline: none;
  }
}

a,
input,
textarea,
.clickable {
  -webkit-tap-highlight-color: transparent;
}

.m-button {
  position: relative;
  overflow: hidden;
  border: 0px;
}

.m-button:after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 5px;
  height: 5px;
  background: rgba(255, 255, 255, 0.5);
  opacity: 0;
  border-radius: 100%;
  transform: scale(1, 1) translate(-50%);
  transform-origin: 50% 50%;
}

@keyframes ripple {
  0% {
    transform: scale(0, 0);
    opacity: 1;
  }
  20% {
    transform: scale(25, 25);
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: scale(40, 40);
  }
}

.m-button:focus:not(:active)::after {
  animation: ripple 0.7s ease-out;
}

#app {
}

.demo {
  position: fixed;
  z-index: 999999999999999;
  opacity: 0.5;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-size: cover;
  background-position: top;
  background-repeat: no-repeat;

  &:hover {
    opacity: 0;
  }
}

.main-tabbar {
  padding-bottom: 26vw;
}

.table {
  table-layout: fixed;
  width: 100%;
  background: white;
  border-collapse: collapse;

  th,
  td {
    @gap: 5vw;
    line-height: 1.5em;
    padding-top: 3vw;
    padding-bottom: 3vw;
    font-size: @textSize30;
  }

  th {
    word-wrap: normal;
    vertical-align: middle;
    white-space: nowrap;
    overflow: hidden;
    background-color: #f0eef4;
    font-weight: normal;
    color: #a4aaae;
    border-bottom: 2px solid #dddae2;
  }

  td {
    text-align: center;
    color: @textColor;
    border-bottom: 1px solid #ebebeb;
    background: #fff;

    a {
      color: @themeColor;
    }
  }
}

.empty-list-tip {
  text-align: center;
  height: 80vh;
  line-height: 80vh;
  color: #666;
}

/*图标*/
.icon {
  display: inline-block;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  width: 3vw;
  height: 3vw;

  &.rotate-180 {
    transform: rotate(180deg);
    transform-origin: center center;
  }
}

.icon-scan {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/v2/scan.png);
}
.icon-scan-white {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/scan-white.png);
}
.icon-message {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/message.png);
}
.icon-search {
  background-image: url(./assets/icon-search.png);
}
.icon-device {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/v2/add-device.png);
}
.icon-shop {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/shops.png);
}
.icon-order {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/v2/orders.png);
}
.icon-verify {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/verify.png);
}
.icon-small-arrow-down {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/small-arrow-down.png);
}
.icon-selected {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/selected.png);
}
.icon-close {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/close.png);
}
.icon-signal {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/signal.png);
}
.icon-online {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/online.png);
}
.icon-offline {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/offline.png);
}
.icon-status-ok {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/status-ok.png);
}
.icon-qr {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/qr.png);
}
.icon-ok-primary {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/ok-primary.png);
}
.icon-info {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/info.png);
}
.icon-arrow-right {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/arrow-right.png);
}
.icon-arrow-down-white {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/v2/arrow-down-white.png);
}
.icon-product {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/product.png);
}
.icon-product-active {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/product-active.png);
}
.icon-upload {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/upload.png);
}
.icon-factory {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/factory.png);
}
.icon-close-circle {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/close_fill_circle.png);
}
.icon-magnifier-white {
  background-image: url(//udian-res.oss-cn-hangzhou.aliyuncs.com/haoku-yun/icons/v2/magnifier-white.png);
}
.icon-menu-arrow {
  background-image: url(./assets/icon-menu-arrow.png);
}

/*block*/
.block-group {
  margin-bottom: 4vw;

  &.last {
    border-bottom: none;
  }

  .block {
    border-bottom: 1px solid #ddd;
    line-height: 2.8em;
    padding-left: 1em;
    padding-right: 1em;
    display: block;
    background: white;

    .title {
      color: #555;
    }

    .sub-title {
      color: #999;
      float: right;
    }
  }
}
/*Form*/
.form-panel {
  width: 90vw;
  margin: 10vw auto 10vw;
  font-size: 3.5vw;

  .control-group {
    line-height: 10vw;
    background: white;
    border: 1px solid #eee;
    border-bottom: none;
    padding: 1.5vw 0;
    position: relative;
    z-index: 1;

    &:last-child {
      border-bottom: 1px solid #eee;
    }

    label {
      color: #777;
      width: 7em;
      display: inline-block;
      padding-left: 1em;
    }

    input {
      border: none;
      color: #aaa;
    }

    .sub-btn,
    .sub-label {
      background: transparent;
      color: #666;
      border: none;
      position: absolute;
      z-index: 2;
      right: 3vw;
    }
  }
}

.control-actions {
  width: 100%;
  text-align: center;
  margin-top: 10vw;

  .btn {
    background-color: rgba(26, 188, 156, 1);
    border: none;
    color: white;
    width: 40vw;
    height: 12vw;
    font-size: 5vw;
    border-radius: 6vw;
    line-height: 10vw;
  }
}

.mask {
  position: fixed;
  top: -1vw;
  left: -1vw;
  right: -1vw;
  bottom: -1vw;
  background: transparent;
}

@keyframes slideInUp {
  0% {
    transform: translate3d(0, 100%, 0);
    visibility: visible;
  }

  to {
    transform: translateZ(0);
  }
}
@keyframes slideOutDown {
  0% {
    transform: translateZ(0);
  }

  to {
    visibility: hidden;
    transform: translate3d(0, 100%, 0);
  }
}

.slideup-enter-active {
  animation-name: slideInUp;
  animation-duration: 0.2s;
  animation-fill-mode: both;
}
.slideup-leave-active {
  animation-name: slideOutDown;
  animation-duration: 0.2s;
  animation-fill-mode: both;
}

.popup-enter-active,
.popup-leave-active{
  transition: all .1s ease;
}

.popup-enter,
.popup-leave-to{
  transform: scale(.7);
  opacity: 0;
}

.popup-enter-to,
.popup-leave{
  transform: scale(1);
  opacity: 1;
}

.van-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0, .6);
  // opacity: .6;
}
</style>



// WEBPACK FOOTER //
// src/App.vue